angular.module('cfn').component('greeningEcologicalFocusArea', {
  bindings: {
    farmId: '<',
    totalArea: '<',
    year: '<'
  },
  controller: GreeningEcologicalFocusAreaController,
  controllerAs: 'vm',
  templateUrl: require('./ecologicalFocusArea.html')
});

GreeningEcologicalFocusAreaController.$inject = [
  '$scope',
  'ECOLOGICAL_FOCUS_AREA_FACTORS',
  'EcologicalFocusArea',
  'tracker'
];
function GreeningEcologicalFocusAreaController(
  $scope,
  ECOLOGICAL_FOCUS_AREA_FACTORS,
  EcologicalFocusArea,
  tracker
) {
  var vm = this;

  $scope.$watch('[vm.year,vm.farmId]', function() {
    EcologicalFocusArea.get(vm.year, vm.farmId).then(function(efa) {
      vm.efa = efa;
    });
  });

  $scope.$watch('vm.totalArea', function() {
    vm.requiredEFA = EcologicalFocusArea.calculateRequiredEFA(vm.totalArea);
  });

  _.extend(vm, {
    efa: null,
    factors: ECOLOGICAL_FOCUS_AREA_FACTORS,
    requiredEFA: null
  });

  _.extend(vm, {
    saveEfa: saveEfa
  });

  function saveEfa() {
    vm.efa.save().finally(function() {
      tracker.trackEvent(
        'CROP_SEQUENCE_PLANNING',
        'save-ecological-focus-area',
        'efa-input-blur'
      );
    });
  }
}
